import { useQuery } from '@tanstack/react-query';
import axios from 'config/axios';
import { PurposeIntentTagList } from '../purposeIntent.types';

async function getGlobalPurposeIntentsList(): Promise<PurposeIntentTagList> {
  const response = await axios.get<PurposeIntentTagList>(
    `GetGlobalPurposeIntentsList`
  );

  if (response.status === 204)
    return {
      intentTags: [],
    };

  return response.data;
}

const useGetGlobalPurposeIntentsList = () =>
  useQuery(['globalPurposeIntents'], () => getGlobalPurposeIntentsList());

export default useGetGlobalPurposeIntentsList;
